module.exports = ['$translateProvider', function ($translateProvider) {
        $translateProvider.useSanitizeValueStrategy('escape');
        $translateProvider.translations('it', require('./languages/it'));
        $translateProvider.translations('en', require('./languages/en'));
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-gMapModule/module-translations.js
// module id = 332
// module chunks = 0